import InvitationDetails from './components/invitation-details'

export default InvitationDetails
